import { render, staticRenderFns } from "./buyOrder.vue?vue&type=template&id=94e5ab1a"
import script from "./buyOrder.vue?vue&type=script&lang=js"
export * from "./buyOrder.vue?vue&type=script&lang=js"
import style0 from "./buyOrder.vue?vue&type=style&index=0&id=94e5ab1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports